import { useRecordContext, useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ParameterExceptionEmpty } from '@/components/parameter/exceptions/ParameterExceptionEmpty.jsx';
import { ParameterSubsetTreeNode } from '@/components/parameter/tree/ParameterSubsetTreeNode.jsx';
import { withSubsetRecordIds } from '@/helpers/parameter/parameterExceptions.js';
import { normalizeParameterRecord } from '@/helpers/parameter/parameterSubsets.js';
import { parameterSubsetTreeStyles } from '@/themes/commonStyles';

const StyledSubsetTree = styled(Box)(parameterSubsetTreeStyles);

export const ParameterSubsetTree = () => {
    const record = useRecordContext();
    const translate = useTranslate();

    if (!record) {
        return null;
    }

    const parameter = normalizeParameterRecord(record);
    const subsets = withSubsetRecordIds(parameter.subsets, parameter.type, `parameter-${parameter.id}`);

    return (
        <StyledSubsetTree>
            <Typography variant='h5' className='parameter-subset-tree-title'>
                {translate('resources.parameter.labels.subsets')}
            </Typography>
            {subsets.length === 0 ? <ParameterExceptionEmpty /> : subsets.map(subset => <ParameterSubsetTreeNode key={subset.id} subset={subset} depth={0} />)}
        </StyledSubsetTree>
    );
};
